import api from "./axios";

// Invoices — admin-only. Append-only on the server (no update endpoint);
// delete + regenerate is the workflow for a mistake.
export const listInvoices = (params = {}) => api.get("/invoices", { params });
export const getInvoice = (id) => api.get(`/invoices/${id}`);
export const prefillInvoice = (params) => api.get("/invoices/prefill", { params });
export const createInvoice = (payload) => api.post("/invoices", payload);
export const updateInvoice = (id, payload) => api.put(`/invoices/${id}`, payload);
export const deleteInvoice = (id) => api.delete(`/invoices/${id}`);
// Lightweight lookup the form calls when the admin flips firm or GST
// treatment mid-form — returns the next invoice_no for the chosen
// (firm, treatment) bucket without re-prefilling everything.
export const getNextInvoiceNumber = (params) =>
  api.get("/invoices/next-number", { params });
